(function () {
  var REVIEW_BUCKET = 'review-images';
  var MAX_FILES = 6;
  var MAX_FILE_SIZE = 8 * 1024 * 1024;

  function waitForSupabase(callback) {
    if (window.CUDOLLA_SUPABASE_CLIENT) {
      callback(window.CUDOLLA_SUPABASE_CLIENT);
      return;
    }

    setTimeout(function () {
      waitForSupabase(callback);
    }, 100);
  }

  function getValue(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.value.trim() : '';
  }

  function getChecked(form, name) {
    var field = form.querySelector('[name="' + name + '"]');
    return field ? field.checked : false;
  }

  function setMessage(form, type, text) {
    var messageBox = form.querySelector('.cudolla-review-message');
    if (!messageBox) return;

    messageBox.className = 'cudolla-review-message ' + type;
    messageBox.textContent = text;
  }

  function cleanFileName(name) {
    return String(name || 'image')
      .toLowerCase()
      .replace(/[^a-z0-9.\-_]/g, '-')
      .replace(/-+/g, '-');
  }

  function buildStoragePath(reviewId, file, index) {
    var ext = file.name && file.name.includes('.') ? file.name.split('.').pop() : 'jpg';
    return reviewId + '/' + Date.now() + '-' + index + '-' + cleanFileName(file.name || ('review-photo.' + ext));
  }

  function validateFiles(files) {
    if (!files || !files.length) return;

    if (files.length > MAX_FILES) {
      throw new Error('Please upload no more than ' + MAX_FILES + ' photos.');
    }

    Array.prototype.forEach.call(files, function (file) {
      if (!file.type || !file.type.startsWith('image/')) {
        throw new Error('Only image files are allowed.');
      }

      if (file.size > MAX_FILE_SIZE) {
        throw new Error('Each photo must be under 8MB.');
      }
    });
  }

  function initStarRatings() {
    document.querySelectorAll('.cudolla-stars').forEach(function (wrap) {
      if (wrap.dataset.ready === 'true') return;
      wrap.dataset.ready = 'true';

      var inputName = wrap.dataset.input;
      var form = wrap.closest('form');
      var input = form ? form.querySelector('[name="' + inputName + '"]') : null;
      var buttons = wrap.querySelectorAll('button');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Number(button.dataset.value);

          if (input) input.value = value;

          buttons.forEach(function (star) {
            var starValue = Number(star.dataset.value);
            star.classList.toggle('active', starValue <= value);
          });
        });
      });
    });
  }

  async function uploadReviewImages(supabase, form, reviewId) {
    var fileInput = form.querySelector('[name="review_images"]');
    var files = fileInput && fileInput._selectedFiles ? fileInput._selectedFiles : [];

    validateFiles(files);

    if (!files.length) return;

    for (var i = 0; i < files.length; i++) {
      var file = files[i];
      var path = buildStoragePath(reviewId, file, i + 1);

      var upload = await supabase.storage
        .from(REVIEW_BUCKET)
        .upload(path, file, {
          cacheControl: '3600',
          upsert: false,
          contentType: file.type
        });

      if (upload.error) throw upload.error;

      var publicData = supabase.storage
        .from(REVIEW_BUCKET)
        .getPublicUrl(path);

      var imageUrl = publicData && publicData.data ? publicData.data.publicUrl : '';

      var imageRecord = await supabase
        .from('review_images')
        .insert([{
          review_id: reviewId,
          image_url: '',
          image_path: path,
          file_name: file.name,
          file_size: file.size,
          mime_type: file.type,
          alt_text: 'CUDOLLA customer review photo',
          status: 'pending',
          visible_publicly: false,
          approved_by_admin: false,
          display_order: i
        }]);

      if (imageRecord.error) throw imageRecord.error;
    }
  }

  function initCustomSelects() {
  document.querySelectorAll('.cudolla-select').forEach(function (select) {
    if (select.dataset.ready === 'true') return;
    select.dataset.ready = 'true';

    var name = select.dataset.name;
    var form = select.closest('form');
    var input = form ? form.querySelector('[name="' + name + '"]') : null;
    var trigger = select.querySelector('.cudolla-select-trigger');
    var triggerText = trigger ? trigger.querySelector('span') : null;
    var options = select.querySelectorAll('.cudolla-select-menu button');

    if (!trigger || !input) return;

    trigger.addEventListener('click', function () {
      document.querySelectorAll('.cudolla-select.open').forEach(function (openSelect) {
        if (openSelect !== select) openSelect.classList.remove('open');
      });

      select.classList.toggle('open');
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        input.value = option.dataset.value || '';
        if (triggerText) triggerText.textContent = option.textContent.trim();

        options.forEach(function (btn) {
          btn.classList.remove('active');
        });

        option.classList.add('active');
        select.classList.remove('open');
      });
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.cudolla-select')) return;

    document.querySelectorAll('.cudolla-select.open').forEach(function (select) {
      select.classList.remove('open');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  prefillReviewProductInfo();
  initStarRatings();
  initCustomSelects();
  initPhotoPreviews();
});

function initPhotoPreviews() {
  document.querySelectorAll('[name="review_images"]').forEach(function (input) {
    if (input.dataset.previewReady === 'true') return;
    input.dataset.previewReady = 'true';

    var form = input.closest('form');
    var preview = form ? form.querySelector('.cudolla-photo-preview') : null;
    var selectedFiles = [];

    function syncInputFiles() {
      var dt = new DataTransfer();

      selectedFiles.forEach(function (file) {
        dt.items.add(file);
      });

      input.files = dt.files;
      input._selectedFiles = selectedFiles;
    }

    function renderPreview() {
      if (!preview) return;

      preview.innerHTML = '';

      selectedFiles.forEach(function (file, index) {
        if (!file.type || !file.type.startsWith('image/')) return;

        var item = document.createElement('div');
        item.className = 'cudolla-photo-item';

        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;

        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'cudolla-remove-photo';
        removeButton.textContent = '×';

        removeButton.addEventListener('click', function () {
          selectedFiles.splice(index, 1);
          syncInputFiles();
          renderPreview();
        });

        item.appendChild(img);
        item.appendChild(removeButton);
        preview.appendChild(item);
      });
    }

    input.addEventListener('change', function () {
  var newFiles = Array.from(input.files || []);

  newFiles.forEach(function (file) {
    if (selectedFiles.length < MAX_FILES) {
      selectedFiles.push(file);
    }
  });

  selectedFiles = selectedFiles.slice(0, MAX_FILES);

  syncInputFiles();
  renderPreview();
});
  });
}
function prefillReviewProductInfo() {
  var params = new URLSearchParams(window.location.search);

  var productHandle = params.get('product_handle') || '';
  var productTitle = params.get('product_title') || '';
  var productId = params.get('product_id') || '';

  document.querySelectorAll('.cudolla-review-form').forEach(function (form) {
    var handleInput = form.querySelector('[name="product_handle"]');
    var titleInput = form.querySelector('[name="product_title"]');
    var idInput = form.querySelector('[name="product_id"]');

    if (handleInput) handleInput.value = productHandle;
    if (titleInput) titleInput.value = productTitle;
    if (idInput) idInput.value = productId;

    if (productTitle) {
      var box = document.createElement('div');
      box.className = 'cud-review-product-context';
      box.innerHTML = 'Reviewing: <strong>' + productTitle + '</strong>';
      form.insertBefore(box, form.firstChild);
    }
  });
}
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.classList.contains('cudolla-review-form')) return;

    event.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
    }

    setMessage(form, '', '');

    waitForSupabase(async function (supabase) {
      try {
        var reviewData = {
          first_name: getValue(form, 'first_name'),
          email: getValue(form, 'email').toLowerCase(),
          rating: Number(getValue(form, 'rating')),
          review_text: getValue(form, 'review_text'),

          product_id: getValue(form, 'product_id'),
          product_handle: getValue(form, 'product_handle'),
          product_title: getValue(form, 'product_title'),

          reservation_number: getValue(form, 'reservation_number'),

          permission_to_publish: getChecked(form, 'permission_to_publish'),

          cleanliness_rating: Number(getValue(form, 'cleanliness_rating')) || null,
          communication_rating: Number(getValue(form, 'communication_rating')) || null,
          delivery_rating: Number(getValue(form, 'delivery_rating')) || null,
          reservation_process_rating: Number(getValue(form, 'reservation_process_rating')) || null,

          would_reserve_again: getValue(form, 'would_reserve_again') === 'yes',
          experience_type: getValue(form, 'experience_type'),

          status: 'pending',
          verification_status: 'pending',
          verified_reservation: false,
          featured: false
        };

        if (!reviewData.first_name || reviewData.first_name.length < 2) {
          throw new Error('Please enter your first name.');
        }

        if (!reviewData.email || !reviewData.email.includes('@')) {
          throw new Error('Please enter a valid email address.');
        }

        if (!reviewData.rating || reviewData.rating < 1 || reviewData.rating > 5) {
          throw new Error('Please select an overall rating.');
        }

        if (!reviewData.cleanliness_rating || !reviewData.communication_rating || !reviewData.delivery_rating) {
  throw new Error('Please complete all rating categories.');
}

        if (!reviewData.review_text || reviewData.review_text.length < 10) {
          throw new Error('Please write a little more about your experience.');
        }

        if (!reviewData.permission_to_publish) {
          throw new Error('Please check the permission box before submitting.');
        }

        var fileInput = form.querySelector('[name="review_images"]');
        validateFiles(fileInput && fileInput._selectedFiles ? fileInput._selectedFiles : []);

        var reviewId = crypto.randomUUID();

reviewData.id = reviewId;

var result = await supabase
  .from('reviews')
  .insert([reviewData]);

if (result.error) throw result.error;

await uploadReviewImages(supabase, form, reviewId);

        form.reset();

        form.querySelectorAll('.cudolla-stars button').forEach(function (star) {
          star.classList.remove('active');
        });

        setMessage(form, 'success', 'Thank you. Your review and photos were received and are pending approval.');

      } catch (error) {
        console.error('CUDOLLA review error:', error);
        setMessage(form, 'error', error.message || 'Something went wrong. Please try again.');
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Submit Review';
      }
    });
  });
})();